import { createContext, useContext } from "react";

/*
 * How a page fills in the topbar.
 *
 * The layout owns two DOM slots inside the topbar — the breadcrumb nav and the
 * actions area — and publishes those nodes through this context. A page renders
 * <PageChrome> which portals into them.
 *
 * Why portals and not context state: `actions` is JSX, so its identity changes
 * on every render of the page. Pushing it into provider state from an effect
 * would either loop or need brittle memo keys. Portals have no state at all —
 * the content mounts with the page and unmounts with it.
 */
export const ChromeSlotsContext = createContext({ crumbs: null, actions: null });

export function useChromeSlots() {
    return useContext(ChromeSlotsContext);
}
